import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';
import { useInputGroupContext } from '../InputGroup/index.js';

const RequiredIndicator = _ref => {
  let {
    isDisabled,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    "aria-hidden": "true",
    as: "span",
    color: isDisabled ? 'watermelon100' : 'inputAlert',
    ml: "space10"
  }, rest), "*");
};
/**
 * InputLabel is used with InputGroup to display a label to an associated form control.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input-group#usage)
 * - [Props](https://blockparty.endpoint.com/components/input-group#props)
 * <br />
 *
 */
const InputLabel = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref2;
  const {
    isDisabled,
    isRequired,
    isInvalid,
    groupId
  } = useInputGroupContext();
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    as: "label",
    color: isDisabled ? 'inputDisabled' : isInvalid ? 'inputAlert' : 'carbon500',
    display: "block",
    fontSize: "fontSize10",
    htmlFor: groupId,
    lineHeight: "lineHeight10",
    mb: "space20"
  }, rest), children, isRequired && /*#__PURE__*/React__default.createElement(RequiredIndicator, {
    isDisabled: isDisabled
  }));
});

export { InputLabel, RequiredIndicator };
